"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCreateVehiclesTypes = void 0;
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateVehiclesTypes_1 = require("./StateVehiclesTypes");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_com_modal_dialogs_1 = require("@ivanlog/gs-com-modal_dialogs");
class StateCreateVehiclesTypes extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageVehiclesType, "New vehicles type", true);
        this._sizeClassOptions = [];
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnDelete.onclick = () => this.tryDelete();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args) {
                if (args instanceof models_1.VehicleType)
                    this._vehicleType = args;
                else if (args.id) {
                    this._vehicleType = yield this.lockgui(this.app.api.admin.directory.getVehicleType(args.id));
                    if (!this._vehicleType)
                        return gs_1.StateRunResultEnum.Failed;
                }
            }
            yield this._loadSizeClassOptions();
            if (this._vehicleType) {
                this._urlArgs["id"] = this._vehicleType.id.toString();
                yield this.fill();
            }
            else {
                this.page.ctrls.btnDelete.hide();
                this._renderSizeClassOptions();
            }
            return _super.start.call(this, args);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._vehicleType) {
                const suffix = this._vehicleType.sizeClass
                    ? ` (${this._vehicleType.sizeClass})`
                    : "";
                this.setLabel(`Vehicle type #${this._vehicleType.id}${suffix}`);
            }
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!this._vehicleType)
                return;
            this.page.ctrls.btnDelete.show();
            const vt = this._vehicleType;
            this._renderSizeClassOptions(vt.sizeClass);
            const fillObj = {
                width: (_a = vt.size) === null || _a === void 0 ? void 0 : _a.width,
                length: (_b = vt.size) === null || _b === void 0 ? void 0 : _b.length,
                height: (_c = vt.size) === null || _c === void 0 ? void 0 : _c.height,
                volume: vt.volume,
                payload: vt.payload,
                sizeClass: vt.sizeClass,
            };
            yield this.page.ctrls.form.fillFormData(fillObj, true);
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            data.size = new models_1.Size(data);
            const req = new models_1.CreateVehicleTypeRequest(data);
            const sizeClass = typeof data.sizeClass === "string" ? data.sizeClass.trim() : "";
            if (!sizeClass) {
                yield new modalCom.DialogOk("Size class is required").show();
                return;
            }
            req.sizeClass = sizeClass;
            if (this._vehicleType) {
                req.name = this._vehicleType.name;
                req.description = this._vehicleType.description;
                req.descriptionShort = this._vehicleType.descriptionShort;
                req.iconFile = this._vehicleType.iconFile;
            }
            const isEdit = !!this._vehicleType;
            const vtype = yield this.lockgui(isEdit
                ? this.app.api.admin.directory.updateVehicleType(this._vehicleType.id, req)
                : this.app.api.admin.directory.createVehicleType(req));
            if (!vtype)
                return;
            if (isEdit) {
                yield this.app.astra.refreshVehiclesType();
                yield this._loadSizeClassOptions();
                this._vehicleType = vtype;
                yield new modalCom.DialogOk("Vehicle type updated").show();
                yield this.fill();
            }
            else {
                yield this.app.astra.refreshVehiclesType();
                yield new modalCom.DialogOk("Vehicle type created").show();
                yield gs_1.StateGS.Run(StateVehiclesTypes_1.StateVehiclesTypes);
            }
        });
    }
    tryDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._vehicleType)
                return;
            const confirm = yield new modalCom.DialogOkNo("Delete this vehicles type and all linked entities?", "Warning").show();
            if (confirm != gs_com_modal_dialogs_1.ModalDialogResult.Ok)
                return;
            const responce = yield this.lockgui(this.app.api.admin.directory.deleteVehicleType(this._vehicleType.id));
            if (!responce)
                return;
            yield new modalCom.DialogOk("Vehicle type deleted").show();
            yield gs_1.StateGS.Run(StateVehiclesTypes_1.StateVehiclesTypes);
        });
    }
    _loadSizeClassOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let vehicleTypes = yield this.app.astra.getVehiclesTypes();
            if (!vehicleTypes || vehicleTypes.length === 0) {
                vehicleTypes = (_a = (yield this.app.astra.refreshVehiclesType())) !== null && _a !== void 0 ? _a : [];
            }
            const options = new Set();
            for (const type of vehicleTypes !== null && vehicleTypes !== void 0 ? vehicleTypes : []) {
                const value = typeof type.sizeClass === "string" ? type.sizeClass.trim() : "";
                if (value)
                    options.add(value);
            }
            if ((_b = this._vehicleType) === null || _b === void 0 ? void 0 : _b.sizeClass) {
                const current = this._vehicleType.sizeClass.trim();
                if (current)
                    options.add(current);
            }
            this._sizeClassOptions = Array.from(options).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
        });
    }
    _renderSizeClassOptions(selected) {
        var _a, _b;
        const element = (_a = this.page.ctrls.selectSizeClass) === null || _a === void 0 ? void 0 : _a.el;
        if (!(element instanceof HTMLSelectElement))
            return;
        const current = ((_b = selected !== null && selected !== void 0 ? selected : element.value) !== null && _b !== void 0 ? _b : "").trim();
        element.innerHTML = "";
        const placeholder = new Option("Select size class", "");
        placeholder.disabled = this._sizeClassOptions.length > 0;
        placeholder.hidden = placeholder.disabled;
        placeholder.selected = !current;
        element.append(placeholder);
        for (const value of this._sizeClassOptions) {
            const option = new Option(value, value, false, value === current);
            element.append(option);
        }
        if (current && element.value !== current) {
            const fallback = new Option(current, current, true, true);
            element.append(fallback);
            element.value = current;
        }
    }
}
exports.StateCreateVehiclesTypes = StateCreateVehiclesTypes;
StateCreateVehiclesTypes.StateName = "newVehiclesType";
//# sourceMappingURL=StateCreateVehiclesTypes.js.map